import type {
  CategoryShare,
  RatingBucket,
  SalesPoint,
  TopProduct,
} from "@/types";

export const salesToday: SalesPoint[] = [
  { label: "١ م", value: 320 },
  { label: "٣ م", value: 540 },
  { label: "٥ م", value: 410 },
  { label: "٧ م", value: 890 },
  { label: "٩ م", value: 1240 },
  { label: "١١ م", value: 980 },
];

export const salesWeek: SalesPoint[] = [
  { label: "السبت", value: 6420 },
  { label: "الأحد", value: 5310 },
  { label: "الاثنين", value: 4980 },
  { label: "الثلاثاء", value: 6120 },
  { label: "الأربعاء", value: 7240 },
  { label: "الخميس", value: 8930 },
  { label: "الجمعة", value: 8420 },
];

export const salesMonth: SalesPoint[] = [
  { label: "أ١", value: 24800 },
  { label: "أ٢", value: 31200 },
  { label: "أ٣", value: 28600 },
  { label: "أ٤", value: 35400 },
];

export const topProducts: TopProduct[] = [
  { name: "كبسة دجاج", sold: 318, revenue: 14310 },
  { name: "مندي لحم", sold: 176, revenue: 11440 },
  { name: "برياني دجاج", sold: 264, revenue: 10032 },
  { name: "حمص بالطحينة", sold: 402, revenue: 6030 },
  { name: "شاي بالنعناع", sold: 517, revenue: 4136 },
];

export const ratingsBreakdown: RatingBucket[] = [
  { stars: 5, count: 198 },
  { stars: 4, count: 71 },
  { stars: 3, count: 26 },
  { stars: 2, count: 11 },
  { stars: 1, count: 6 },
];

export const categoryShare: CategoryShare[] = [
  { name: "الوجبات الرئيسية", percent: 52, color: "oklch(var(--primary-500))" },
  { name: "المقبلات", percent: 18, color: "oklch(var(--accent-500))" },
  { name: "المشروبات", percent: 20, color: "oklch(var(--secondary-500))" },
  { name: "الحلويات", percent: 10, color: "oklch(var(--primary-700))" },
];

export const reportSummary = {
  range: {
    today: { sales: 8420.5, orders: 128, avg: 65.78, growth: 12 },
    week: { sales: 47420, orders: 742, avg: 63.9, growth: 8 },
    month: { sales: 120000, orders: 1864, avg: 64.4, growth: 15 },
  },
};

export const appFeesSummary = {
  today: {
    total: 9.6,
    orders: 12,
    avg: 0.8,
    electronic: 7.2,
    electronicOrders: 9,
    cash: 2.4,
    cashOrders: 3,
    branches: [
      { id: "b1", name: "فرع العليا", orders: 7, fee: 0.8, amount: 5.6 },
      { id: "b3", name: "فرع الملقا", orders: 3, fee: 0.8, amount: 2.4 },
      { id: "b2", name: "فرع النخيل", orders: 2, fee: 0.8, amount: 1.6 },
    ],
  },
  week: {
    total: 61.6,
    orders: 77,
    avg: 0.8,
    electronic: 48,
    electronicOrders: 60,
    cash: 13.6,
    cashOrders: 17,
    branches: [
      { id: "b1", name: "فرع العليا", orders: 42, fee: 0.8, amount: 33.6 },
      { id: "b3", name: "فرع الملقا", orders: 21, fee: 0.8, amount: 16.8 },
      { id: "b2", name: "فرع النخيل", orders: 14, fee: 0.8, amount: 11.2 },
    ],
  },
  month: {
    total: 227.2,
    orders: 284,
    avg: 0.8,
    electronic: 174.4,
    electronicOrders: 218,
    cash: 52.8,
    cashOrders: 66,
    branches: [
      { id: "b1", name: "فرع العليا", orders: 160, fee: 0.8, amount: 128 },
      { id: "b3", name: "فرع الملقا", orders: 78, fee: 0.8, amount: 62.4 },
      { id: "b2", name: "فرع النخيل", orders: 46, fee: 0.8, amount: 36.8 },
    ],
  },
};

export const deliveryFeesSummary = {
  today: {
    total: 165,
    orders: 11,
    avg: 15,
    branches: [
      { id: "b1", name: "فرع العليا", enabled: true, orders: 11, fee: 15, amount: 165 },
      { id: "b2", name: "فرع النخيل", enabled: false, orders: 0, fee: 0, amount: 0 },
      { id: "b3", name: "فرع الملقا", enabled: false, orders: 0, fee: 0, amount: 0 },
      { id: "b4", name: "فرع الحمراء", enabled: false, orders: 0, fee: 0, amount: 0 },
    ],
  },
  week: {
    total: 945,
    orders: 63,
    avg: 15,
    branches: [
      { id: "b1", name: "فرع العليا", enabled: true, orders: 63, fee: 15, amount: 945 },
      { id: "b2", name: "فرع النخيل", enabled: false, orders: 0, fee: 0, amount: 0 },
      { id: "b3", name: "فرع الملقا", enabled: false, orders: 0, fee: 0, amount: 0 },
      { id: "b4", name: "فرع الحمراء", enabled: false, orders: 0, fee: 0, amount: 0 },
    ],
  },
  month: {
    total: 3780,
    orders: 252,
    avg: 15,
    branches: [
      { id: "b1", name: "فرع العليا", enabled: true, orders: 252, fee: 15, amount: 3780 },
      { id: "b2", name: "فرع النخيل", enabled: false, orders: 0, fee: 0, amount: 0 },
      { id: "b3", name: "فرع الملقا", enabled: false, orders: 0, fee: 0, amount: 0 },
      { id: "b4", name: "فرع الحمراء", enabled: false, orders: 0, fee: 0, amount: 0 },
    ],
  },
};